import { Component, OnInit, ViewEncapsulation,  Input, Output, EventEmitter  } from '@angular/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { ReactivosService } from 'app/main/wizard-cgo/services/reactivos.service';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import * as backInter from 'app/auth/auth-data.model';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import {lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
@Component({
  selector: 'app-select-reactivo',
  templateUrl: './select-reactivo.component.html',
  styleUrls: ['./select-reactivo.component.scss']
})
export class SelectReactivoComponent implements OnInit {
  productoCertificar: backInter.prodCert;
  productoFocus: backInter.prodFocusArea;
  idiomas: backInter.getIdiomas;
  preguntasTraduccionesAdicionalesFocus: backInter.respuestaTraduccionesPreguntasAdicionalesFocus;
  pasoCompleto=false;
  // sinIdiomasAdiconales=false;
  statusModal: number;
  @Output() pasoCompletoFinal: EventEmitter<boolean> = new EventEmitter();
  traduccionesPreguntas:boolean;
  traduccionesPreguntasOpciones:boolean;

  userData:any;
  validationUser:boolean=false;
  desbloqueoEstatus:boolean=false;


  constructor(
    private _snackBar: MatSnackBar,
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private reactivosService: ReactivosService,
    private adicionalesService: AdicionalesService,

  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

        lang_modales.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        if(localStorage.getItem('userBypass')){
        this.userData=JSON.parse(localStorage.getItem('userBypass'));
        // console.log(this.userData.level);
        if(this.userData.level==3 || this.userData.level==2){
          this.validationUser=true;
        }
        else{
          this.validationUser=false;
        }
        }
}

  ngOnInit() {
  this.obtieneCertificarActual();

  }
  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.reactivosService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsFocusArea:backInter.prodFocusArea[] = data.productosFocusArea;
      var BreakException = {};
      try {
          prodsFocusArea.forEach( (producto) => {
            let fecha = producto.fechaFocus;
            let idProducto = producto.idFocusArea;
            console.log(fecha+'-'+parseInt(localStorage.getItem('fechaProducto'))+'*'+idProducto+'-'+ localStorage.getItem('productoID'));
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoFocus = producto;
              this.getEstatusDesbloqueo();
              console.log(this.productoFocus);
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.reactivosService.getStatusReactivosFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.getStatusIndiv) => {
        console.log(data);
        if(data.estatus === 3)
          this.pasoCompleto = true;
      });
      this.obtieneIdiomasGuardados();
      this.getStatusModal();
      this.obtieneTraduccionesAdicionalesFocus();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      //console.log("error al recuperar certificar vigente");
    });
  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoFocus.idFocusArea).subscribe((respuesta:any) => {
      // console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  desbloquearReactivos(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          this.reactivosService.desbloquearPasoReactivosFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '218'){
               this.pasoCompleto = false;
               this.enviaOrdenWizard();
               this.openSnackBar(succes,"OK");
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,
               
               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,
        
        confirmButtonText: cerrar,
        })
      }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  completarPaso(){
    console.log(this.traduccionesPreguntas);
    console.log(this.traduccionesPreguntasOpciones);
    if(this.traduccionesPreguntas) {

       this.aletaRestric('REACTIVOS.COMPLETAR',true);

            // this.bloqueaSeccionAdicional=true;

        }else{
          let rspSi = 'MODALES.ACCIONES.aceptar';
          let texto = 'MODALES.VALIDACION.ERROR1';
          this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
          this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
          Swal.fire({
            icon: 'warning',
            title: texto,
            confirmButtonText: rspSi,
            confirmButtonColor: '#e40601'
          });
        }




    // this.ValidarTraducciones();
  }
  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.reactivosService.guardaStatusReactivosFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.RespuestaGen) => {
            console.log(data);
            
            if(data.message == '218'){
              this.aletaRestric('REACTIVOS.'+data.message,null,'success');
             
              this.pasoCompleto = true;
              this.pasoCompletoFinal.emit(true);

              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      if(tipo == 'warning'){
        Swal.fire({
          icon: 'warning',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }
      else if(tipo == 'success'){
        this.openSnackBar(texto,"OK");
        /*Swal.fire({
          icon: 'success',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });*/
      }
    }

  }


  obtieneIdiomasGuardados(){
    // this.adicionalesService.getIdiomas().subscribe( (data: backInter.getIdiomas) => {
    let fechaProducto: backInter.getIdiomaFechas = {fechaFocus:this.productoFocus.fechaFocus};
  console.log(fechaProducto);

    localStorage.setItem('FechaFocusArea',this.productoFocus.fechaFocus.toString());
    this.adicionalesService.getListaIdiomasFocus().subscribe( (data: backInter.getIdiomas) => {
      this.idiomas = data;
      this.idiomas.idiomas.forEach(element => {
        console.log(element.tipoIdioma);

      });
      console.log(data);
    });
  }


  getStatusModal(){
    let datos={
      encuestaID: localStorage.getItem('encuestaID'),
      reactivos: 1
    };
    console.log(datos);
    this.wizardService.getStatusModalFocus(datos).subscribe( (data: backInter.getStatusModal) => {
      this.statusModal=data.estatus;
      if(data.estatus==1){
            this.modalInformativo('REACTIVOS');
      }
    });
  }
  updateStatusModal(){
    let datos={
      encuestaID: localStorage.getItem('encuestaID'),
      reactivos: 2  };
    // console.log(datos);
    this.wizardService.updateStatusModalFocus(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }


  obtieneTraduccionesAdicionalesFocus(){
    let datos:any= {seccion: 2, empresaId:localStorage.getItem('companyID')};
    let datos2:any={};
    this.adicionalesService.getTraduccionesAdicionalFocus(datos).subscribe( (data:backInter.respuestaTraduccionesPreguntasAdicionalesFocus) => {
      this.preguntasTraduccionesAdicionalesFocus = data;
      console.log(this.preguntasTraduccionesAdicionalesFocus)
      if (this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.length==0) {
        this.traduccionesPreguntas= true;
      }
      this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.forEach(element => {
        if (element.preguntas.length==0) {
          console.log("djsbsa");
          this.traduccionesPreguntas= true;
          // this.traduccionesPreguntasOpciones= true;

        }else{
        element.preguntas.forEach(elementOpciones => {

          console.log(elementOpciones);
          if(elementOpciones.tipoRespuesta!=3){
            console.log("entro estes vise con adicionales ");
            if(elementOpciones.traduccion==""){
              datos2={encontroUno:true}
              // this.traduccionesPreguntas= false;
              // console.log(this.traduccionesPreguntas);

            }else{
              this.traduccionesPreguntas= true;
              console.log(this.traduccionesPreguntas);


            }
            // if(elementOpciones.opciones.length==0){
            //   this.traduccionesPreguntasOpciones= true;
            //   console.log(this.traduccionesPreguntasOpciones);
            //
            // }

           //  elementOpciones.opciones.forEach(element => {
           //      if(element.traduccion==""){
           //        this.traduccionesPreguntasOpciones= false;
           //        console.log(this.traduccionesPreguntasOpciones);
           //      }else{
           //        this.traduccionesPreguntasOpciones= true;
           //          console.log(this.traduccionesPreguntasOpciones);
           //      }
           // });
         }else{
           console.log("entro este visne sin adicionales ");
           this.traduccionesPreguntas= true;
           // this.traduccionesPreguntasOpciones= true;

         }



     });
     console.log(datos2);

     if (datos2.encontroUno==true) {
       this.traduccionesPreguntas= false;

     }else{
       this.traduccionesPreguntas= true;
     }
   }

      });



      // if(this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.length >0){
      //   this.sinIdiomasAdiconales=true;
      //   console.log(this.sinIdiomasAdiconales);
      //
      //
      // }else{
      //   this.sinIdiomasAdiconales=false;
      //   console.log(this.sinIdiomasAdiconales);
      // }


    });
  }

  actualizarAdicionales(orden: boolean){
    console.log("si se mando a actualizar",orden);

    if(orden){
    this.obtieneTraduccionesAdicionalesFocus();
    }
  }

}
